/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FormProfileSnapshot } from '../../models/form-profile-snapshot';

export interface FindOneFormProfileSnapshot$Params {
  formId: string;
}

export function findOneFormProfileSnapshot(
  http: HttpClient,
  rootUrl: string,
  params: FindOneFormProfileSnapshot$Params,
  context?: HttpContext
): Observable<StrictHttpResponse<FormProfileSnapshot>> {
  const rb = new RequestBuilder(rootUrl, findOneFormProfileSnapshot.PATH, 'get');
  if (params) {
    rb.path('formId', params.formId, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<FormProfileSnapshot>;
    })
  );
}

findOneFormProfileSnapshot.PATH = '/forms/{formId}/profile-snapshot';
